var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurserviceimg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM6.25 16.25H3.75V3.75H6.25V16.25ZM13.75 11.875H8.75C8.58424 11.875 8.42527 11.8092 8.30806 11.6919C8.19085 11.5747 8.125 11.4158 8.125 11.25C8.125 11.0842 8.19085 10.9253 8.30806 10.8081C8.42527 10.6908 8.58424 10.625 8.75 10.625H13.75C13.9158 10.625 14.0747 10.6908 14.1919 10.8081C14.3092 10.9253 14.375 11.0842 14.375 11.25C14.375 11.4158 14.3092 11.5747 14.1919 11.6919C14.0747 11.8092 13.9158 11.875 13.75 11.875ZM13.75 9.375H8.75C8.58424 9.375 8.42527 9.30915 8.30806 9.19194C8.19085 9.07473 8.125 8.91576 8.125 8.75C8.125 8.58424 8.19085 8.42527 8.30806 8.30806C8.42527 8.19085 8.58424 8.125 8.75 8.125H13.75C13.9158 8.125 14.0747 8.19085 14.1919 8.30806C14.3092 8.42527 14.375 8.58424 14.375 8.75C14.375 8.91576 14.3092 9.07473 14.1919 9.19194C14.0747 9.30915 13.9158 9.375 13.75 9.375Z",
    fill: "#1D6DC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurserviceimg2);
export default __webpack_public_path__ + "static/media/ourserviceimg2.610709f2da074b67908e91a0c7ccb7a1.svg";
export { ForwardRef as ReactComponent };